import { BaseComponent } from '../../../../components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { HBox, VBox } from '../../../../components/Box';
import { makeSelectLocale } from '../../../../containers/LanguageProvider/selectors';
import { translateCountry } from '../../../Companies/translate-countries';

const STATE = {
  edit: null,
  value: '',
  addCompanyAddress: false,
  addValue: '',
  deleteAddressConfirm: null,
  addCountryId: null,
  address: { countryId: null, typeId: 2 },
  fieldErrors: null,
  standardLocation: null,
  currentStandard: null,
};

const Address = styled.div`
  border: 1px solid rgb(21, 172, 121);
  border-radius: 6px;
  padding: 12px;
  width: 100%;
  margin: 6px 0;
  font-size: 12px;

  .button {
    margin: 0 -12px;
  }
  .name {
    font-size: 12px;
  }
  .address {
    margin-top: 12px;
  }
`;

const SelectedAddress = styled.div`
  border: 3px solid rgb(21, 172, 121);
  border-radius: 6px;
  padding: 12px;
  width: 100%;
  margin: 6px 0;
  font-size: 12px;

  .button {
    margin: 0 -12px;
  }
  .name {
    font-size: 12px;
  }
  .address {
    margin-top: 12px;
  }
`;

class InvoiceAddressComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  get locale() {
    return this.props.locale;
  }

  onSelect() {
    this.props.onSelect(this.props.address.id);
  }

  renderFields() {
    return (
      <VBox left>
        <HBox vCenter>
          <h3 className="name">{this.lbl(`address.type.${this.props.address?.type?.name || 'other'}`)}</h3>
        </HBox>
        <VBox className="address" left>
          <div>{this.props.address.addressLine1}</div>
          <div>
            {this.props.address.postcode} {this.props.address.city}
          </div>
          <div>{translateCountry(this.props.address.country?.name, this.locale)}</div>
        </VBox>

        <VBox className="address" left>
          <strong>{this.lbl('company.details.comment')}</strong>
          {this.props.address.description}
        </VBox>
      </VBox>
    );
  }

  render() {
    console.log('this.props.address', this.props.address);
    if (this.props.selected) {
      return (
        <SelectedAddress key={`${this.props.address.id}`} onClick={this.onSelect.bind(this)}>
          {this.renderFields()}
        </SelectedAddress>
      );
    }

    return (
      <Address key={`${this.props.address.id}`} onClick={this.onSelect.bind(this)}>
        {this.renderFields()}
      </Address>
    );
  }
}

InvoiceAddressComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    locale: makeSelectLocale(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const InvoiceAddress = compose(withConnect, withRouter, injectIntl)(InvoiceAddressComp);
